import { AfterViewInit, Directive, input } from '@angular/core'
import { effect, signal } from '@angular/core'
import { inject } from '@angular/core'

import { FlxInfoHelperComponent } from '@flowx/angular-ui-toolkit'
import { fonts, theme } from '@flowx/core-sdk'
import { HelperOverrides, applyHelperTooltipCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-info-helper',
  standalone: true,
  host: {
    '[class]': 'styleClassName()',
  },
})
export class FlxHelperTooltipStyleDirective implements AfterViewInit {
  #helperComponent = inject(FlxInfoHelperComponent)

  componentStyle = input<{
    style: HelperOverrides
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyHelperTooltipCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }

  ngAfterViewInit(): void {
    // subscription here automatically ends on directive destroy (signal output)
    this.#helperComponent.tooltip().showTooltip.subscribe(async ({ hostElement }) => {
      const styleClasses = await applyHelperTooltipCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      hostElement.classList.add(styleClasses)
    })
  }
}
